import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ChangeIconGuard } from '../misc/guards/change-icon.guard';
import { GuestGuard } from '../misc/guards/guest.guard';
import { ReferralCodeGuard } from '../misc/guards/referral-code.guard';
import { RegisteredGuard } from '../misc/guards/registered.guard';
import { ChangePasswordPageModule } from '../misc/pages/change-password/change-password.module';
import { TermsPageModule } from '../misc/pages/terms/terms.module';
import { ChangeIconPageModule } from './change-icon/change-icon.module';
import { LoginPageModule } from './login/login.module';
import { ReferralPageModule } from './referral/referral.module';
import { RegisterPageModule } from './register/register.module';

const routes: Routes = [
  {
    canActivate: [GuestGuard],
    loadChildren: () => ReferralPageModule,
    path: 'referral'
  },
  {
    canActivate: [GuestGuard, ReferralCodeGuard],
    data: {
      isOnboardingFlow: true
    },
    loadChildren: () => TermsPageModule,
    path: 'terms'
  },
  {
    canActivate: [GuestGuard, ReferralCodeGuard],
    loadChildren: () => RegisterPageModule,
    path: 'register'
  },
  {
    canActivate: [GuestGuard, ReferralCodeGuard, RegisteredGuard],
    loadChildren: () => LoginPageModule,
    path: 'login'
  },
  {
    canActivate: [GuestGuard, ReferralCodeGuard, RegisteredGuard],
    data: {
      isOnboardingFlow: true
    },
    loadChildren: () => ChangePasswordPageModule,
    path: 'change-password'
  },
  {
    canActivate: [ReferralCodeGuard, RegisteredGuard, ChangeIconGuard],
    loadChildren: () => ChangeIconPageModule,
    path: 'change-icon'
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'referral'
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)]
})
export class OnboardingRoutingModule {}
